import WarningIcon from '@mui/icons-material/Warning'
import { LoadingButton } from '@mui/lab'
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'

import { useVehiclePreDeleteValidationQuery } from 'generated/graphql'

interface IDeleteVehicleDialogProps {
  open: boolean
  processing?: boolean
  onConfirm: () => void
  onClose: () => void
  vehicleId: number
  driverId: number
}

const DeleteVehicleDialog = (options: IDeleteVehicleDialogProps) => {
  const { open, processing, onConfirm, onClose, vehicleId, driverId } = options

  const { data: vehicleCheckData, loading: checkingVehicle } = useVehiclePreDeleteValidationQuery({
    fetchPolicy: 'network-only',
    variables: {
      vehicleId: vehicleId,
      driverId: driverId,
    },
    skip: !open || !vehicleId || !driverId,
  })

  const loading = processing || checkingVehicle
  // TODO:

  const hasWarning =
    true /* vehicleCheckData?.vehicle?.hasBids || vehicleCheckData?.vehicle?.isDefault */

  return (
    <Dialog maxWidth='xs' onClose={onClose} open={open}>
      <DialogTitle>
        Are you sure you want to delete this vehicle? This action cannot be undone.
      </DialogTitle>
      <DialogContent>
        {loading && (
          <CircularProgress
            style={{
              marginLeft: '45%',
              marginTop: '10px',
            }}
            color='primary'
          />
        )}

        {hasWarning && (
          <DialogContent>
            <WarningIcon style={{ marginLeft: '45%' }} color='warning' />
            {vehicleCheckData?.vehicle?.hasBids && (
              <DialogContentText>
                - This vehicle has bids associated with it. Deleting this vehicle will remove all
                associated bids. Please confirm that you want to proceed with this action.
              </DialogContentText>
            )}
            {/* {vehicleCheckData?.vehicle?.isDefault && (
              <DialogContentText>
                - This vehicle is set as the default vehicle. Deleting this vehicle will remove it
                as the default vehicle. Please confirm that you want to proceed with this action.
              </DialogContentText>
            )} */}
          </DialogContent>
        )}
      </DialogContent>

      <DialogActions>
        <Button variant='contained' color='grey' onClick={onClose}>
          Cancel
        </Button>
        <LoadingButton loading={loading} variant='contained' color='error' onClick={onConfirm}>
          Proceed
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteVehicleDialog
